import { THEMES } from 'src/constants';

export default {
    siteName: 'demo',
    senderName: 'Warbox Demo',
    logo: '/static/warbox_logo.png',
    name: 'Warbox Demo',
    bureauSite: 'demo.warbox.io',
    theme: THEMES.ONE_DARK,
    client: 'demo',
    themes: [
        { theme: 'LIGHT', name: 'LIGHT' },
        { theme: 'ONE_DARK', name: 'DARK' },
        { theme: 'DARK_PINK', name: 'DARK PINK' },
        { theme: 'LIGHT_PINK', name: 'LIGHT PINK' },
        { theme: 'DARK_BLUE', name: 'DARK BLUE' },
        { theme: 'LIGHT_BLUE', name: 'LIGHT BLUE' },
        { theme: 'DARK_RED', name: 'DARK RED' },
        { theme: 'LIGHT_RED', name: 'LIGHT RED' },
        { theme: 'DARK_REGGAE', name: 'DARK REGGAE' },
        { theme: 'LIGHT_REGGAE', name: 'LIGHT REGGAE' },
        { theme: 'DARK_LILA', name: 'DARK LILA' },
        { theme: 'LIGHT_LILA', name: 'LIGHT LILA' },
    ],
};
